import { render } from "./SceneTree.vue?vue&type=template&id=0b7db9eb&ts=true"
import script from "./SceneTree.vue?vue&type=script&lang=ts"
export * from "./SceneTree.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__